import React from 'react';
import FormikLikeInput from '../../../../../../../components/formikFileds/likeInput';

interface IOptionalSimpleInputsProps {
  name: string;
  placeholder?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
}

function OptionalSimpleInput({
  name,
  placeholder,
  onChange,
  label,
}: IOptionalSimpleInputsProps) {
  return (
    <div className="flex flex-col w-full">
      <FormikLikeInput
        name={name}
        placeholder={placeholder}
        label={label || ''}
        onChange={onChange}
        disabled={false}
      />
    </div>
  );
}

export default OptionalSimpleInput;
